/**
 *
 *  a dedicated class for doing positioning
 * @param {*} configurations
 * @param {*} context optional document object to cater parent and iframe based DOM manipulation alike
 * @returns
 */
import Browser from '../hooks/Browser';
import getFixedTop from '../hooks/getFixedTop';
import getViewport from '../hooks/getViewport';
import WidgetsCache from '../WidgetsCache';
import { ChatbarPosition, Position } from '../enums/Enum';
import WidgetTypes from '../enums/WidgetTypes';
import Positioner from './Positioner';

export default class DropDownPositioner extends Positioner {
    constructor(configurations, context) {
        super(configurations, context);
        const me = this;
        me.configuration = configurations;
        me.DOM = context || document;
    }

    position(options) {
        const me = this;
        const tempDOM = me.DOM;
        if (options.context) {
            me.DOM = options.context;
        }

        const { element, position, model } = options;
        const pureElement = this.getPureElement(element);
        const targetObj = this.getElement(element, pureElement);
        const dims = getViewport();
        const halfHeight = dims[1] / 2 - targetObj.offsetHeight / 2;
        let end =
            position == Position.Center ||
                position == Position.LeftCenter ||
                position == Position.RightCenter
                ? `${halfHeight}px`
                : '0px';
        let attr = 'bottom';
        // for IE, we deal with the top of the invitation
        if (Browser.isIE()) {
            attr = 'top';
            end = getFixedTop(position, targetObj);
        }
        if (
            !(
                position == Position.TopLeft ||
                position == Position.TopMiddle ||
                position == Position.TopRight
            )
        ) {
            targetObj.style[attr] = end;
        } else {
            targetObj.style.top = end;
        }
        let barWidget = null;
        try {
            barWidget = WidgetsCache.get(WidgetTypes.Bar);
        } catch (error) { }

        if (model && model.overflow) {
            targetObj.style.overflow = 'visible'; // we need it visible
        }
        if (model && model.bottom) {
            targetObj.style.bottom = model.bottom;
        }
        // left/right adjustments
        switch (position) {
            case Position.TopRight:
            case Position.RightCenter:
            case Position.Right:
                targetObj.style.left = 'auto';
                targetObj.style.right = '0px';
                if (model && model.right) {
                    targetObj.style.right = model.right;
                }
                break;
            case Position.Left:
                targetObj.style.left = '0px';
                if (model && model.left) {
                    targetObj.style.left = model.left;
                }
                break;
            case Position.TopLeft:
                targetObj.style.right = 'auto';
                targetObj.style.left = '0px';
                break;
            case Position.Center:
            case Position.Middle:
            case Position.TopMiddle:
                targetObj.style.right = 'auto';
                targetObj.style.left = `${dims[0] / 2 - targetObj.offsetWidth / 2}px`;
                targetObj.style.left = 'auto';
                targetObj.style.right = '0px';
                targetObj.style.top = '0px';
                break;
            default:
        }
        if (model && model.preChat) {
            targetObj.style.marginBottom = `${model.preChat.preChatMarginFromBottom}px`;
        }
        if (barWidget) {
            const height = document.getElementById(barWidget.parentDivId).offsetHeight;
            const width = document.getElementById(barWidget.parentDivId).offsetWidth;
            if (
                barWidget.options.chatbar.position == ChatbarPosition.Bottom &&
                (position == Position.Right ||
                    position == Position.Middle ||
                    position == Position.Left)
            ) {
                if (
                    me.configuration &&
                    me.configuration.preChat &&
                    me.configuration.preChat.preChatMarginFromBottom &&
                    targetObj.id === `${WidgetTypes.PreChat}_wrapper`
                ) {
                    targetObj.style.marginBottom = `
                        ${me.configuration.preChat.preChatMarginFromBottom + height}px
                    `;
                } else {
                    targetObj.style.marginBottom = `${height}px`;
                }
            } else if (
                barWidget.options.chatbar.position == ChatbarPosition.Top &&
                (position == Position.TopRight ||
                    position == Position.TopMiddle ||
                    position == Position.TopLeft)
            ) {
                targetObj.style.marginTop = `${height}px`;
            } else if (
                barWidget.options.chatbar.position == ChatbarPosition.Left &&
                (position == Position.TopLeft ||
                    position == Position.LeftCenter ||
                    position == Position.Left)
            ) {
                targetObj.style.marginLeft = `${width}px`;
            } else if (
                barWidget.options.chatbar.position == ChatbarPosition.Right &&
                (position == Position.TopRight ||
                    position == Position.RightCenter ||
                    position == Position.Right)
            ) {
                targetObj.style.marginRight = `${width}px`;
            }
        }

        me.DOM = tempDOM;
    }
}
